import { useEffect, useState } from 'react'

type StoredDataType = string | Record<string, string>

export function useLocalStorage<T extends StoredDataType>(
  storageKey: string,
  fallbackState: T,
): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    const storedValue = window.localStorage.getItem(storageKey)

    if (!storedValue) {
      return fallbackState
    }

    try {
      return JSON.parse(storedValue)
    } catch (_error) {
      return fallbackState
    }
  })

  useEffect(() => {
    window.localStorage.setItem(storageKey, JSON.stringify(value))
  }, [value, storageKey])

  return [value, setValue]
}
